var map = {
	"./icon-alarm.svg": 8306,
	"./icon-business.svg": 3555,
	"./icon-dashboard.svg": 2860,
	"./icon-device.svg": 2072,
	"./icon-profile.svg": 6836,
	"./icon-setting.svg": 4707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;